/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GoalOverviewSubType = (typeof GoalOverviewSubType)[keyof typeof GoalOverviewSubType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoalOverviewSubType = {
  none: "none",
  sub_goal: "sub_goal",
  housing_property: "housing_property",
  housing_mortgage: "housing_mortgage",
  housing_other: "housing_other",
  early_age: "early_age",
  primary_school: "primary_school",
  high_school: "high_school",
  university: "university",
  start_to_life: "start_to_life",
} as const;
